import React, { useMemo } from 'react';

import { Button, Picker } from '@gogame/components';
import { useChildComponent } from '@gogame/hooks-ts';
import { useIsAllowed } from '@gogame/permissions';

import { EventFormCreate } from 'scenes/Events/components/EventForm';
import { MANAGE_GAME_EVENTS } from 'scenes/Events/constants';

export const EventPicker = ({
  selectedOptions = [],
  onChange,
  disabled,
  data,
  loading,
  reload,
}) => {
  const canMangeEvents = useIsAllowed()(MANAGE_GAME_EVENTS);

  const [childComponent, showChildComponent] = useChildComponent();

  const unselectedOptions = useMemo(() => {
    if (data?.length) {
      return data.filter((app) => !selectedOptions.includes(app.id));
    }
    return [];
  }, [data, selectedOptions]);

  const handleAddEvent = () => {
    showChildComponent(EventFormCreate, {
      onChange: (value) => {
        reload();
        onChange([value]);
      },
    });
  };

  return (
    <React.Fragment>
      <Picker
        button={<Button add>Event</Button>}
        disabled={disabled}
        onChange={onChange}
        options={unselectedOptions}
        loading={loading}
        withSelectAll={true}
        {...(canMangeEvents
          ? {
              onAdd: handleAddEvent,
              addOptionLabel: 'Add event',
            }
          : null)}
      />
      {childComponent}
    </React.Fragment>
  );
};
